module.exports = __webpack_public_path__ + "static/media/neritoLogoGreen.f88e90ce.svg";